import { Text } from "@chakra-ui/react";

export const SalesCannotCreateNewVersionOfSaleWithPaidBillsError = () => {
  return (
    <Text>
      Cette vente contient des paiements inclus dans des factures clôturées
    </Text>
  );
};
